import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import getServerSideArticles
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/serverSide/getServerSideArticles';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import EmergingMarketArticles from '@/creditflowresearch/ui/components/creditFlow/articles/EmergingMarketArticles';
import getServerSideArticlesBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideArticlesBreadcrumbs';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const articlesData = await getServerSideArticles(context);

  const breadcrumbs = getServerSideArticlesBreadcrumbs(context.query);

  return {
    props: {
      articlesData,
      breadcrumbs,
    },
  };
}, { needsLegacyDictionaries: false });

export default ({ articlesData }) => (
  <PageFiltersContextProvider>
    <PageContentLayout>
      <EmergingMarketArticles articlesData={ articlesData } />
    </PageContentLayout>
  </PageFiltersContextProvider>
);
